import React from 'react'
import styled from 'styled-components'
import Icons, { CloseIcon } from '../Icons'
import styles from './style.module.scss'

export const Modal = ({title, active, children, width}) => {
  const widthAsNumber = Number(width.replace(/\D/g, ""))

  const ModalContent = styled.div`
    width: ${width};
    @media (max-width: ${widthAsNumber + 30}px) {
      width: calc(100% - 30px) !important;
    }
  `

  return (
    <section className={`${styles.modal} ${active.status ? styles['modal--active'] : null}`}>
      <ModalContent className={styles['modal__content']} style={{width}}>
        {
          title && title.text ? 
            <header className={styles['modal__header']}>
              <button type="button" onClick={() => active.onChange(false)}>
                <CloseIcon />  
              </button>
              <h2 className={styles['modal__title']}>
                {
                  title.icon ?
                    (() => {
                      const Component = Icons[title.icon]
                      return <Component size="small"/>
                    })()
                  : null
                }

                {title.text}
              </h2>
            </header>
          : null
        }

        {children}
      </ModalContent>

      <div className={styles['modal__backdrop']} onClick={() => active.onChange(false)}></div>
    </section>
  )
}